// Centralised UI text in German and English.
export const dict = {
  de: {
    nav: {
      home: "Startseite",
      services: "Leistungen",
      managed_security: "Managed Security",
      managed_backup: "Backup & Recovery",
      managed_server: "Server Hosting",
      schwachstellen: "Schwachstellen­management",
      managed_wlan: "Managed WLAN",
      webdesign: "Webdesign & SEO",
      website_check: "Webseiten-Check",
      cameras: "Überwachungskameras",
      local_ai: "Lokale KI",
      managed_services: "Managed Services",
      blog: "Blog",
      contact: "Kontakt",
      admin: "Admin",
    },
    cta: {
      call_now: "Jetzt anrufen",
      learn_more: "Mehr erfahren",
      get_started: "Beratung anfragen",
      contact_us: "Kontakt aufnehmen",
      view_all: "Alle anzeigen",
      back_home: "Zur Startseite",
    },
    home: {
      eyebrow: "Ihr IT-Dienstleister · Made in Germany",
      headline_a: "IT-Sicherheit",
      headline_b: "mit Sachverstand.",
      sub: "IT-Service, IT-Beratung und Managed Security aus einer Hand: Über 10 Jahre Expertise für den deutschen Mittelstand. Wir schützen, was Sie nicht verlieren dürfen.",
      stats: [
        { value: "10+", label: "Jahre Erfahrung" },
        { value: "24/7", label: "Monitoring" },
        { value: "100%", label: "Hosting in DE" },
        { value: "0€", label: "Versteckte Kosten" },
      ],
      services_eyebrow: "Was wir tun",
      services_title: "Unsere IT-Services",
      services_sub: "Professionelle Hard- und Software-Lösungen mit zertifiziertem Personal und qualifizierten Herstellern.",
      values_eyebrow: "Warum IT-Servicepoint",
      values_title: "Schutz auf höchstem Niveau.",
      values_sub: "Wir liefern keine Marketingversprechen, sondern handfeste IT-Sicherheit. Bedrohungs- und Schwachstellenanalysen, Viren- und Ransomwarebeseitigung, Datenrettung und Backup-Strategien gehören zu unserem täglichen Doing.",
      threats_eyebrow: "Aktuelle Bedrohungslage",
      threats_title: "Effektiver Schutz vor Ransomware, Viren und Cyberangriffen.",
      cta_block_title: "Bereit für IT-Sicherheit, die hält?",
      cta_block_sub: "Wir analysieren Ihre Infrastruktur und liefern einen konkreten Maßnahmenplan – unverbindlich.",
    },
    service_tiles: [
      { key: "local-ai", title: "Lokale KI", desc: "Eigene, DSGVO-konforme KI im Haus – für Kanzleien, Steuerbüros & vertrauliche Daten.", href: "/lokale-ki" },
      { key: "managed-services", title: "Managed Services", desc: "Firewall, Antivirus, XDR, Backup & Exchange – 5 Services, 1 Partner, 1 Rechnung.", href: "/managed-services" },
      { key: "managed-security", title: "Managed Security", desc: "UTM-Firewall, Mail-Security, MDM & Awareness als Rundum-Schutzschild.", href: "/managed-security" },
      { key: "managed-backup", title: "Backup & Recovery", desc: "3-2-1-Backup mit Air-Gap – Wiederherstellung in unter 15 Minuten.", href: "/managed-backup" },
      { key: "managed-server", title: "Server Hosting", desc: "Managed Windows- & Linux-Server aus deutschen Rechenzentren.", href: "/managed-server" },
      { key: "schwachstellen", title: "Schwachstellenmanagement", desc: "Greenbone-Scans, CVSS-Bewertung und automatisierte Patch-Zyklen.", href: "/schwachstellenmanagement" },
      { key: "managed-wlan", title: "Managed WLAN", desc: "Stabiles Firmen-WLAN mit zentralem Controller – Basic, Silber oder Plus.", href: "/managed-wlan" },
      { key: "cameras", title: "Überwachungskameras", desc: "Reolink 4G-Kameras – Videoüberwachung ganz ohne WLAN & Stromanschluss.", href: "/ueberwachungskameras" },
      { key: "webdesign", title: "Webdesign & SEO", desc: "Schnelle, mobile Webseiten mit lokalem SEO – zum Festpreis ab 1.000 €.", href: "/webdesign" },
      { key: "website-check", title: "Webseiten-Check", desc: "Kostenloser 60-Sekunden-Check: Score, Detail-Report & Empfehlungen.", href: "/webseiten-check" },
    ],
    services_overview: [
      {
        key: "managed-security",
        title: "Managed Security",
        desc: "Firewall, AV-Schutz und Mail-Security als Managed Service – ohne Leasing, ohne Finanzierung.",
        href: "/managed-security",
      },
      {
        key: "managed-backup",
        title: "Managed Backup & Restore",
        desc: "Datensicherung und Wiederherstellung mit Active Protection in der IT-Servicepoint Cloud.",
        href: "/managed-backup",
      },
      {
        key: "managed-server",
        title: "Managed Server Hosting",
        desc: "Windows Server günstig mieten – volle Admin-Rechte und KVM-Virtualisierung inklusive.",
        href: "/managed-server",
      },
      {
        key: "schwachstellen",
        title: "Schwachstellen­management",
        desc: "Risiken erkennen, bewerten und beheben – mit Greenbone, kontinuierlichem Scan und CVSS-Bewertung.",
        href: "/schwachstellenmanagement",
      },
      {
        key: "managed-wlan",
        title: "Managed WLAN",
        desc: "Stabiles Firmen-WLAN mit zentralem Controller, Dashboard und Support – Basic, Silber oder Plus.",
        href: "/managed-wlan",
      },
      {
        key: "webdesign",
        title: "Webdesign & SEO",
        desc: "Professionelle Webseiten für jede Branche – aus Fulda, Bad Hersfeld, Kassel, Würzburg. Schnell, mobil, sichtbar bei Google.",
        href: "/webdesign",
      },
      {
        key: "datenrettung",
        title: "Datenrettung",
        desc: "Professionelle Rettung von Festplatten, USB-Medien und mobilen Datenträgern in unserem Reinraum-Netzwerk.",
        href: "/managed-backup",
      },
    ],
    threats: [
      { title: "Ransomware", body: "Verschlüsselt Daten und fordert Lösegeld. Schutz: Air-Gap Backups, EDR und sofortige Patches." },
      { title: "Phishing & E-Mail", body: "Das häufigste Einfallstor. Schutz: Spam-Filter, Awareness-Training, mehrstufige Analyse." },
      { title: "Zero-Day Exploits", body: "Lücken in nicht-gepatchter Software. Schutz: Schwachstellen-Scans und Patch-Management." },
      { title: "Insider-Risiken", body: "Unachtsame oder böswillige Mitarbeitende. Schutz: Zugriffskontrollen und Monitoring." },
    ],
    footer: {
      tagline: "IT-Sicherheit mit Sachverstand.",
      legal: "Rechtliches",
      services: "Leistungen",
      company: "Unternehmen",
      contact: "Kontakt",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      copyright: "Alle Rechte vorbehalten.",
    },
    contact: {
      title: "Sprechen wir über Ihre IT.",
      sub: "Schreiben Sie uns – wir melden uns innerhalb von 24 Stunden mit einer Einschätzung zurück.",
      name: "Ihr Name",
      email: "E-Mail-Adresse",
      phone: "Telefon (optional)",
      subject: "Betreff",
      message: "Wie können wir helfen?",
      send: "Anfrage senden",
      sent: "Vielen Dank! Wir melden uns kurzfristig.",
      error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      info_title: "IT-Servicepoint",
      info_address: "Im Wiesengrund 2A · 36277 Schenklengsfeld",
      info_owner: "Inhaber: Ron Kowalewsky",
    },
    blog: {
      title: "Blog & Insights",
      sub: "Aktuelle Themen rund um IT-Sicherheit, Compliance und Managed Services.",
      read_more: "Weiterlesen",
      back: "Zurück zum Blog",
      empty: "Noch keine Beiträge veröffentlicht.",
      published_on: "Veröffentlicht am",
    },
    admin: {
      login_title: "Admin-Anmeldung",
      email: "E-Mail",
      password: "Passwort",
      sign_in: "Anmelden",
      sign_out: "Abmelden",
      dashboard: "Dashboard",
      posts: "Beiträge",
      messages: "Nachrichten",
      new_post: "Neuer Beitrag",
      edit_post: "Beitrag bearbeiten",
      save: "Speichern",
      delete: "Löschen",
      title_de: "Titel (Deutsch)",
      title_en: "Titel (Englisch)",
      excerpt_de: "Kurzbeschreibung (DE)",
      excerpt_en: "Kurzbeschreibung (EN)",
      content_de: "Inhalt (DE) · Markdown",
      content_en: "Inhalt (EN) · Markdown",
      cover: "Coverbild URL",
      tags: "Tags (Komma-getrennt)",
      published: "Veröffentlicht",
      cancel: "Abbrechen",
    },
    common: {
      lang: "EN",
      loading: "Lädt …",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      managed_security: "Managed Security",
      managed_backup: "Backup & Recovery",
      managed_server: "Server Hosting",
      schwachstellen: "Vulnerability Mgmt",
      managed_wlan: "Managed WiFi",
      webdesign: "Web Design & SEO",
      website_check: "Website Check",
      cameras: "Surveillance Cameras",
      local_ai: "Local AI",
      managed_services: "Managed Services",
      blog: "Blog",
      contact: "Contact",
      admin: "Admin",
    },
    cta: {
      call_now: "Call us now",
      learn_more: "Learn more",
      get_started: "Request consultation",
      contact_us: "Get in touch",
      view_all: "View all",
      back_home: "Back to home",
    },
    home: {
      eyebrow: "Your IT service provider · Made in Germany",
      headline_a: "IT security",
      headline_b: "done right.",
      sub: "10+ years of expertise in managed security, backup and cloud hosting for German SMBs. We protect what you can't afford to lose.",
      stats: [
        { value: "10+", label: "Years experience" },
        { value: "24/7", label: "Monitoring" },
        { value: "100%", label: "DE hosting" },
        { value: "0€", label: "Hidden cost" },
      ],
      services_eyebrow: "What we do",
      services_title: "Our IT services",
      services_sub: "Professional hardware and software solutions delivered by certified staff and trusted vendors.",
      values_eyebrow: "Why IT-Servicepoint",
      values_title: "Protection at the highest level.",
      values_sub: "No marketing promises – just hard, measurable IT security. Threat and vulnerability analysis, malware removal, data recovery and backup strategies are our daily business.",
      threats_eyebrow: "Threat landscape",
      threats_title: "Effective protection against ransomware, viruses and cyber attacks.",
      cta_block_title: "Ready for IT security that holds?",
      cta_block_sub: "We analyse your infrastructure and deliver a concrete plan – free and without obligation.",
    },
    service_tiles: [
      { key: "local-ai", title: "Local AI", desc: "Your own GDPR-compliant AI in-house – for law firms, tax offices & confidential data.", href: "/lokale-ki" },
      { key: "managed-services", title: "Managed Services", desc: "Firewall, antivirus, XDR, backup & Exchange – 5 services, 1 partner, 1 invoice.", href: "/managed-services" },
      { key: "managed-security", title: "Managed Security", desc: "UTM firewall, mail security, MDM & awareness as an all-round shield.", href: "/managed-security" },
      { key: "managed-backup", title: "Backup & Recovery", desc: "3-2-1 backup with air gap – restore in under 15 minutes.", href: "/managed-backup" },
      { key: "managed-server", title: "Server Hosting", desc: "Managed Windows & Linux servers from German data centres.", href: "/managed-server" },
      { key: "schwachstellen", title: "Vulnerability Management", desc: "Greenbone scans, CVSS scoring and automated patch cycles.", href: "/schwachstellenmanagement" },
      { key: "managed-wlan", title: "Managed WiFi", desc: "Reliable business WiFi with central controller – Basic, Silver or Plus.", href: "/managed-wlan" },
      { key: "cameras", title: "Surveillance Cameras", desc: "Reolink 4G cameras – video surveillance without WiFi or mains power.", href: "/ueberwachungskameras" },
      { key: "webdesign", title: "Web Design & SEO", desc: "Fast, mobile websites with local SEO – fixed price from €1,000.", href: "/webdesign" },
      { key: "website-check", title: "Website Check", desc: "Free 60-second check: score, detailed report & recommendations.", href: "/webseiten-check" },
    ],
    services_overview: [
      { key: "managed-security", title: "Managed Security", desc: "Firewall, AV protection and mail security as a managed service – no leasing, no financing.", href: "/managed-security" },
      { key: "managed-backup", title: "Managed Backup & Restore", desc: "Backup and recovery with active protection in the IT-Servicepoint cloud.", href: "/managed-backup" },
      { key: "managed-server", title: "Managed Server Hosting", desc: "Windows Server for rent – full admin rights and KVM virtualisation included.", href: "/managed-server" },
      { key: "schwachstellen", title: "Vulnerability Management", desc: "Identify, evaluate, fix – with Greenbone, continuous scanning and CVSS scoring.", href: "/schwachstellenmanagement" },
      { key: "managed-wlan", title: "Managed WiFi", desc: "Stable corporate WiFi with central controller, dashboard and support – Basic, Silver, Plus.", href: "/managed-wlan" },
      { key: "webdesign", title: "Web Design & SEO", desc: "Professional websites for every industry – from Fulda, Bad Hersfeld, Kassel, Würzburg. Fast, mobile, visible on Google.", href: "/webdesign" },
      { key: "datenrettung", title: "Data Recovery", desc: "Professional recovery from HDDs, SSDs, USB and mobile media.", href: "/managed-backup" },
    ],
    threats: [
      { title: "Ransomware", body: "Encrypts data and demands ransom. Defense: air-gap backups, EDR and immediate patching." },
      { title: "Phishing & Email", body: "The most common entry point. Defense: spam filters, awareness training, multi-stage analysis." },
      { title: "Zero-day exploits", body: "Holes in unpatched software. Defense: vulnerability scans and patch management." },
      { title: "Insider risk", body: "Careless or malicious staff. Defense: access controls and monitoring." },
    ],
    footer: {
      tagline: "IT security done right.",
      legal: "Legal",
      services: "Services",
      company: "Company",
      contact: "Contact",
      impressum: "Imprint",
      datenschutz: "Privacy",
      copyright: "All rights reserved.",
    },
    contact: {
      title: "Let's talk about your IT.",
      sub: "Drop us a message – we reply within 24 hours with an initial assessment.",
      name: "Your name",
      email: "Email address",
      phone: "Phone (optional)",
      subject: "Subject",
      message: "How can we help?",
      send: "Send request",
      sent: "Thank you! We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      info_title: "IT-Servicepoint",
      info_address: "Im Wiesengrund 2A · 36277 Schenklengsfeld",
      info_owner: "Owner: Ron Kowalewsky",
    },
    blog: {
      title: "Blog & Insights",
      sub: "News and deep dives about IT security, compliance and managed services.",
      read_more: "Read more",
      back: "Back to blog",
      empty: "No posts published yet.",
      published_on: "Published on",
    },
    admin: {
      login_title: "Admin sign-in",
      email: "Email",
      password: "Password",
      sign_in: "Sign in",
      sign_out: "Sign out",
      dashboard: "Dashboard",
      posts: "Posts",
      messages: "Messages",
      new_post: "New post",
      edit_post: "Edit post",
      save: "Save",
      delete: "Delete",
      title_de: "Title (German)",
      title_en: "Title (English)",
      excerpt_de: "Excerpt (DE)",
      excerpt_en: "Excerpt (EN)",
      content_de: "Content (DE) · Markdown",
      content_en: "Content (EN) · Markdown",
      cover: "Cover image URL",
      tags: "Tags (comma-separated)",
      published: "Published",
      cancel: "Cancel",
    },
    common: {
      lang: "DE",
      loading: "Loading …",
    },
  },
};
